import "./SubmissionSuccessModal.scss";

import Button from "components/Button/Button";
import { useIntakeToken } from "utils/context";

import { useOrganizationSlug } from "../hooks/useOrganizationSlug";

type SubmissionSuccessModalProps = {
  isVisible: boolean;
  onCompleteAnother: () => void;
};

const SubmissionSuccessModal = ({
  isVisible,
  onCompleteAnother,
}: SubmissionSuccessModalProps) => {
  const { setIntakeToken, setIntakeUser } = useIntakeToken();
  const organizationSlug = useOrganizationSlug();

  const handleLogOut = () => {
    setIntakeToken(null);
    setIntakeUser(null);
    window.location.href = `/intake/${organizationSlug || "allan-koba"}/auth/login`;
  };

  const handleCompleteAnother = () => {
    onCompleteAnother();
  };

  if (!isVisible) return null;

  return (
    <div className="success-modal-overlay">
      <div className="success-modal-content">
        <div className="success-icon">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="checkmark-icon"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
            <path
              d="m9 12 2 2 4-4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 className="success-title">Submission Successful</h2>

        <p className="success-message">
          Your intake form has been submitted successfully. Our team will review
          your file submission.
        </p>

        <div className="success-actions">
          <Button className="primary-button" onClick={handleCompleteAnother}>
            Complete Another
          </Button>
          <Button onClick={handleLogOut}>Log Out</Button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionSuccessModal;
